import styles from './PageHeader.module.css'
import { AdminIcon } from './AdminIcon'

export function PageHeader({ title, subtitle, breadcrumbs, actions, loading }) {
  return (
    <div className={styles.header}>
      <div className={styles.headerText}>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
            {breadcrumbs.map((crumb, i) => (
              <span key={i} className={styles.breadcrumbItem}>
                <a href={crumb.href} className={styles.breadcrumbLink}>{crumb.label}</a>
                <AdminIcon name="chevron-right" size={14} className={styles.breadcrumbSep} />
              </span>
            ))}
            <span className={styles.breadcrumbCurrent}>{title}</span>
          </nav>
        )}
        <h2 className={styles.title}>{title}</h2>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && (
        <div className={styles.actions}>
          {actions}
        </div>
      )}
    </div>
  )
}
